import { useState, useEffect } from "react";

/* Width alone is the wrong test. A tablet in landscape clears 1024px and would
   get draggable windows, 20px control buttons and 5px resize grips, all far
   under the 44px a finger needs. `pointer: fine` asks for a precise pointer
   instead, so touch devices keep the plain responsive site at any width. */
export const DESKTOP_QUERY = "(min-width: 1024px) and (pointer: fine)";

/**
 * True only once we're on the client, the viewport is desktop-sized, and the
 * primary input is a precise pointer.
 *
 * Starts false so the server-rendered markup and the first client render agree.
 * Everything that depends on this stays out of the SSR output by design.
 */
export const useIsDesktop = () => {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const mql = window.matchMedia(DESKTOP_QUERY);
    const sync = (e) => setIsDesktop(e.matches);

    sync(mql);
    mql.addEventListener("change", sync);
    return () => mql.removeEventListener("change", sync);
  }, []);

  return isDesktop;
};
